import { Xid } from 'xid-ts'
import {
    Exercise,
    ExerciseKinds,
    Lesson,
    Note,
    PersonalScheduleProgram,
    Program,
    Schedule,
    ScheduleItemKinds
} from '.'

export const kindsListReps: ExerciseKinds[] = [
    'repsOnly',
    'weightReps',
    'exercise'
]
export const kindsListDistance: ExerciseKinds[] = ['distance']
export const kindsListDuration: ExerciseKinds[] = ['duration']

export function NewExercise(kind: ExerciseKinds, name?: string): Exercise {
    return {
        id: new Xid().toString(),
        kind,
        exercise: name,
        sets: [{ repetitions: 0, weight: 0 }]
    }
}

export function NewNote(text = ''): Note {
    return {
        id: new Xid().toString(),
        kind: 'note',
        text
    }
}

export function DummyWorkoutLesson(name: string): Lesson {
    return {
        id: new Xid().toString(),
        name,
        items: []
    }
}

export function NewSchedule(kind?: ScheduleItemKinds): Schedule {
    return {
        id: new Xid().toString(),
        kind
    }
}

export function DummyProgram(): Program {
    const id = new Xid().toString()
    return {
        id,
        originalProgramId: id,
        published: false,
        name: '',
        status: 'draft',
        schedule: [],
        lessons: [],
        cost: 0
    }
}

export function DummyPersonalScheduleProgram(): PersonalScheduleProgram {
    return {
        id: '',
        programId: '',
        originalProgramId: '',
        status: 'draft',
        startDate: '',
        endDate: 0,
        starTime: '',
        schedule: [],
        history: []
    }
}
